import { render, staticRenderFns } from "./menzhen-edit.vue?vue&type=template&id=568e9536"
import script from "./menzhen-edit.vue?vue&type=script&lang=ts"
export * from "./menzhen-edit.vue?vue&type=script&lang=ts"
import style0 from "./menzhen-edit.vue?vue&type=style&index=0&id=568e9536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports